/**
 * Global Loading 模块
 * 为全局的阻塞性加载动画，单例模式
 * 提供 show/ close 两个函数
 */
import { Module } from 'vuex'
import { RootState } from '../types'
import { LoadingState } from './types'

enum mutationTypes {
  UPDATE_SHOW_LOADING = 'UPDATE_SHOW_LOADING',
}

const initialState: LoadingState = {
  show: false,
}

export const loading: Module<LoadingState, RootState> = {
  namespaced: true,
  state: initialState,
  actions: {
    show({ commit }): void {
      commit(mutationTypes.UPDATE_SHOW_LOADING, true)
    },
    close({ commit }): void {
      commit(mutationTypes.UPDATE_SHOW_LOADING, false)
    },
  },
  mutations: {
    [mutationTypes.UPDATE_SHOW_LOADING](state, showLoading: boolean): void {
      state.show = showLoading
    },
  },
}
